import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.board.pagination');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'wiz-portal-board-pagination',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.board.pagination/view.scss */
:host {
  display: block;
  width: 100%;
}`],
})
export class PortalBoardPaginationComponent implements OnInit {
    @Input() total: number = 0;
    @Input() page: number = 1;
    @Input() pageSize: number = 20;
    @Input() maxPages: number = 10;
    @Input() size: string = 'md';
    @Input() align: string = 'center';
    @Input() showInfo: boolean = true;
    @Input() showFirstLast: boolean = true;
    @Output() pageChange = new EventEmitter<number>();

    public async ngOnInit() { }

    public get totalPages(): number {
        return Math.max(1, Math.ceil(this.total / this.pageSize));
    }

    public get pages(): number[] {
        const total = this.totalPages;
        const current = this.page;
        const max = this.maxPages;

        let start = Math.max(1, current - Math.floor(max / 2));
        let end = Math.min(total, start + max - 1);

        if (end - start + 1 < max) {
            start = Math.max(1, end - max + 1);
        }

        const pages: number[] = [];
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    }

    public get hasPrev(): boolean {
        return this.page > 1;
    }

    public get hasNext(): boolean {
        return this.page < this.totalPages;
    }

    public get startItem(): number {
        return (this.page - 1) * this.pageSize + 1;
    }

    public get endItem(): number {
        return Math.min(this.page * this.pageSize, this.total);
    }

    public goToPage(page: number) {
        if (page < 1 || page > this.totalPages || page === this.page) return;
        this.pageChange.emit(page);
    }

    public prevPage() {
        this.goToPage(this.page - 1);
    }

    public nextPage() {
        this.goToPage(this.page + 1);
    }

    public firstPage() {
        this.goToPage(1);
    }

    public lastPage() {
        this.goToPage(this.totalPages);
    }

    public get alignClass(): string {
        switch (this.align) {
            case 'left': return 'justify-start';
            case 'right': return 'justify-end';
            default: return 'justify-center';
        }
    }

    public get btnSizeClass(): string {
        switch (this.size) {
            case 'sm': return 'w-7 h-7 text-xs';
            case 'lg': return 'w-10 h-10 text-sm';
            default: return 'w-8 h-8 text-xs';
        }
    }
}

export default PortalBoardPaginationComponent;